import React from 'react'
import {Button, Tooltip} from 'antd'
import styles from './SpotItem.module.scss'
import {useSpotId} from '../../hooks/useSpotId'
import {useComponentLocale} from '../../hooks/useComponentLocale'
import {getStack} from '../../Hands/utils'
import {useSelector} from 'react-redux'
import {Progress} from 'antd'
import {HandsIcon} from "../../helpers/icons";
import {WarningOutlined} from "@ant-design/icons";

export default function SpotItem({spot, spotWidth, spotError, spotDone, jobId, status}) {
    const {librariesResponse} = useSelector((state) => state.libs)
    const [spotId, libName] = useSpotId(spot.spot_name)
    const stack = getStack(spotId, librariesResponse)
    const clickHandler = () => {
        window.open(
            `/hands?filter=${JSON.stringify({
                source: 'uploadPage',
                jobId,
                spot: spotId.toString(),
                lib: libName.replace('&', ' and '),
                targetTab: 'hands',
                stack: stack.join(','),
            })}&nosave=1`,
            '_blank'
        )
    }

    const getTagColor = (status) => {
        switch (status) {
            case 'Done':
                return '#FFB4A9'
            case 'Parsed':
            case 'Running': {
                return '#5C8EF0'
            }
        }
    }

    const getLocale = useComponentLocale()
    const errorsLocale = getLocale({component: 'uploadPage', section: 'errors_hands'})
    const handsLocale = getLocale({component: 'common', section: 'hands'})

    return (
        <div className={styles.spotWrapper}>
            <div className={styles.spotContainer}>
                <div className={styles.spotInfoContainer}>
                    <div>{spot.spot_name}</div>
                    <div>
                        {   spotError > 0 ?
                            <Tooltip
                                style={{width: '300px'}}
                                placement={'rightBottom'}
                                title={
                                    <span style={{fontSize: '0.8rem', width: '300px'}}>
                                        <p>
                                            {spotError} hands were not analyzed for this task
                                        </p>
                                        <p>
                                            You can find them in "Hands" and contact support team for resolving the issue
                                        </p>
                                    </span>
                                }
                            >
                                <WarningOutlined style={{color: '#ff5c5c', cursor: 'pointer', marginRight: 8}} size={"small"}/>
                            </Tooltip>
                            : null
                        }
                        <span>{spot.overall} {handsLocale}</span>

                    </div>
                </div>

                <div>
                    <Progress
                        percent={spotWidth}
                        success={{
                            percent: spotDone * spotWidth / spot.overall,
                            strokeColor: '#00A661',
                        }}
                        size='small'
                        showInfo={false}
                        strokeColor={getTagColor(status)}
                        status={status === 'Running' ? 'active' : 'normal'}
                    />
                </div>
            </div>

            <Button
                className={styles.viewBtn}
                onClick={clickHandler}
                icon={<HandsIcon className={styles.viewBtnIcon}/>}
            />
        </div>
    )
}
